import { usePage } from '@inertiajs/react';
import React from 'react';
import useRoute from '@/Hooks/useRoute';
import AppLayout from '@/Layouts/AppLayout';
import { motion } from 'framer-motion';
import UpdateUserLinksForm from '@/Domains/Links/UpdateUserLinksInfomationForm';
import AddNewLinkForm from '@/Domains/Links/AddNewLinkForm';
import UpdateLinksForm from '@/Domains/Links/UpdateLinksForm';
import SectionBorder from '@/Components/Surfaces/SectionBorder';

export default function Show({ user }) {
  const route = useRoute();
  const page = usePage();

  const animateDashboard = {
    initial: { opacity: 1 },
    animate: { opacity: 1 },
  };

  return (
    <AppLayout title="Links">
      <motion.div
        variants={animateDashboard}
        initial="initial"
        animate="animate"
        exit="exit"
        className="mb-12"
      >
        <div className="mx-auto w-full max-w-screen-md bg-light">
          <div>
            <UpdateUserLinksForm user={page.props.user} />
            <SectionBorder />
          </div>
          <div>
            <AddNewLinkForm user={page.props.user} />
            <SectionBorder />
          </div>
          <div>
            <UpdateLinksForm user={page.props.user} />
          </div>
        </div>
      </motion.div>
    </AppLayout>
  );
}
